var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnersScreens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.7047C4 9.42998 4 8.79265 4.144 8.26998C4.32808 7.60283 4.68211 6.99485 5.17149 6.50547C5.66087 6.0161 6.26885 5.66206 6.936 5.47798C7.45867 5.33398 8.096 5.33398 9.37067 5.33398H21.6C23.84 5.33398 24.96 5.33398 25.816 5.76998C26.5686 6.15347 27.1805 6.76537 27.564 7.51798C28 8.37398 28 9.49398 28 11.734V20.2673C28 22.5073 28 23.6273 27.564 24.4833C27.1805 25.2359 26.5686 25.8478 25.816 26.2313C24.96 26.6673 23.84 26.6673 21.6 26.6673H18.8627",
    stroke: "#139CFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 26.6667C14.6667 23.8377 13.5429 21.1246 11.5425 19.1242C9.54209 17.1238 6.82898 16 4 16M4 26.672L4.472 26.2M9.33333 26.6667C9.33333 25.2522 8.77143 23.8956 7.77124 22.8954C6.77104 21.8952 5.41449 21.3333 4 21.3333",
    stroke: "#139CFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersScreens);
export default __webpack_public_path__ + "static/media/partners-screens.553b8d2e7be167d33cddf45f2f627200.svg";
export { ForwardRef as ReactComponent };